module.exports = __webpack_public_path__ + "img/XX-Studio-Ghibli-Inspired-Tattoos-26__700.jpg";